'use client';
import { jsx } from 'react/jsx-runtime';
import { Dialog, useDialogContext } from '@seed-design/react-dialog';
import { Primitive } from '@seed-design/react-primitive';
import { dialog } from '@seed-design/css/recipes/dialog';
import { forwardRef } from 'react';
import { createSlotRecipeContext } from '../../utils/createSlotRecipeContext.js';
import { createWithStateProps } from '../../utils/createWithStateProps.js';

const { withRootProvider, withContext } = createSlotRecipeContext(dialog);
const withStateProps = createWithStateProps([useDialogContext]);
const DialogRoot = withRootProvider(Dialog.Root, {
  defaultProps: {
    lazyMount: true,
    unmountOnExit: true
  }
});
const DialogTrigger = Dialog.Trigger;
const DialogPositioner = withContext(
  Dialog.Positioner,
  "positioner"
);
const DialogBackdrop = withContext(
  Dialog.Backdrop,
  "backdrop"
);
const DialogContent = withContext(
  Dialog.Content,
  "content"
);
const DialogHeader = withContext(Primitive.div, "header");
const DialogTitle = withContext(
  withStateProps(Primitive.span),
  "title"
);
const DialogDescription = withContext(
  withStateProps(Primitive.div),
  "description"
);
const DialogFooter = withContext(Primitive.div, "footer");
const DialogAction = forwardRef((props, ref) => {
  const api = useDialogContext();
  return /* @__PURE__ */ jsx(Primitive.button, { ...props, ref, onClick: () => api.setOpen(false) });
});

export { DialogAction, DialogBackdrop, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogPositioner, DialogRoot, DialogTitle, DialogTrigger };
